import { jsxs as i, Fragment as d, jsx as t } from "react/jsx-runtime";
import { useTranslation as u } from "react-i18next";
import a from "@mui/material/Box";
import x from "@mui/material/Divider";
import r from "@mui/material/Grid";
import D from "@mui/material/Typography";
import { makeStyles as g } from "tss-react/mui";
import { useLanguageContext as h } from "@lumirental/lumi-web-shared/lib/contexts/Language.context";
import n from "@lumirental/lumi-web-shared/lib/utils/date/getLocaleDayMonth";
import { useBusRentalContext as y } from "../../BusRental.context.js";
import k from "./TripDateForm.style.js";
import p from "../../components/DatePicker/DatePicker.js";
const v = g()(k), T = () => {
  const { classes: o } = v(), { t: c } = u(), { language: e } = h(), { pickupDate: m, dropoffDate: s } = y(), l = m && n(m, e), f = s && n(s, e);
  return /* @__PURE__ */ i(d, { children: [
    /* @__PURE__ */ t(D, { variant: "h6", className: o.groupLabel, children: c("trip_dates") }),
    /* @__PURE__ */ t(
      x,
      {
        sx: { marginTop: 2, marginBottom: 2 },
        className: o.divider
      }
    ),
    /* @__PURE__ */ i(r, { container: !0, columnSpacing: 3, children: [
      /* @__PURE__ */ t(r, { item: !0, xs: 12, sm: 6, mb: { xs: 1, sm: 0 }, children: /* @__PURE__ */ t(a, { mb: { xs: 2, sm: 0 }, children: /* @__PURE__ */ t(p, { id: "pickupDate", value: l }) }) }),
      /* @__PURE__ */ t(r, { item: !0, xs: 12, sm: 6, mb: { xs: 1, sm: 0 }, children: /* @__PURE__ */ t(a, { children: /* @__PURE__ */ t(p, { id: "dropoffDate", value: f }) }) })
    ] })
  ] });
}, _ = T;
export {
  _ as default
};
